angular.module('impactx.search').component('ixContactList', {
        bindings: {
            contacts: '<',
            trns: '<',
            baseObject: "<"
        },
        require: {
            containerCtrl: '^^ixListTabContainer'
        },
        controller: 'ContactSearchListCtrl',
        controllerAs: 'contactSearchListCtrl',
        templateUrl: 'modules/search/templates/contact-list.html'
    }
);
